// extracted by mini-css-extract-plugin
export default {"resend":"BkFLkZPbc7fjtjJUVE58"};